import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-record-latency',
  templateUrl: './help-record-latency.component.html',
  styleUrls: ['./help-record-latency.component.scss']
})
export class HelpRecordLatencyComponent implements ContentModel {
  static ref = HelpModel.LATENCY_TEST;
  static title = 'Record Latency Test';

  showBackHeader = true;

  helpTitle = HelpRecordLatencyComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
